import { render, staticRenderFns } from "./cards.vue?vue&type=template&id=196172b0&scoped=true&"
import script from "./cards.vue?vue&type=script&lang=js&"
export * from "./cards.vue?vue&type=script&lang=js&"
import style0 from "./cards.vue?vue&type=style&index=0&id=196172b0&prod&lang=scss&"
import style1 from "./cards.vue?vue&type=style&index=1&id=196172b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196172b0",
  null
  
)

export default component.exports